/**
 * Copyright (c) 2019, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import styled from 'styled-components';
import { Toggle } from '../../../../components/Form';
import styles from '../../../../styles';

const Wrapper = styled.div``;

const Table = styled.table`
  width: 100%;
`;

const HeaderRow = styled.tr`
  height: 2rem;
  background-color: #54698d;
`;

const ColumnHeader = styled.tr`
  height: 2rem;
  background-color: #e6ecf2;
`;

const HeaderCell = styled.th`
  padding-left: 1rem;
  display: 'table-cell';
  ${styles.fonts.headingLabelCaps}
  align-items: center;
  text-transform: uppercase;
  width: 25%;
  @media (max-width: 767px) {
    width: 25%;
    height: 50px;
    color: #54698d;
    height: 50px;
    box-shadow: 0 1px 0 0 #dddbda;
    background-color: #fafaf9;
  }
`;

const HeaderCellWhiteText = styled(HeaderCell)`
  color: white;
`;

const DataRow = styled.tr`
  width: 100%;
  &:hover {
    background-color: #f0f8fc;
  }
  @media (max-width: 767px) {
    color: #16325c;
  }
`;

const ActionRow = styled.tr`
  box-shadow: 0 1px 0 0 #dddbda;
  background-color: #f3f2f2;
  width: 100%;
  height: 2rem;
  border-top: 1px solid #d8dde6;
  @media (max-width: 767px) {
    height: 5rem;
    font-size: 1rem;
  }
`;

const DataCell = styled.td`
  width: 25%;
  padding-left: 1rem;
  height: 1.75rem;
  vertical-align: middle;
  font-size: 13px;
  color: #16325c;
  border-bottom: 1px solid #d8dde6;
  display: 'table-cell';

  @media (max-width: 767px) {
    height: 60px;
    letter-spacing: normal;
    &:first-child {
      padding-left: 1.25rem;
    }
  }
`;

const NoResultsDataCell = styled(DataCell)`
  border: none;
  &:hover {
    background-color: white;
  }
`;

const SubscriptionsTable = ({
  rows,
  columns,
  className,
  children,
  showColumns,
  noneText,
  hasActionRow,
  onEmailSubscribeToggle,
  onSmsSubscribeToggle,
  emailSubscribed,
  smsSubscribed
}) => (
  <Wrapper className={className}>
    <Table>
      <thead>
        {showColumns && (
          <ColumnHeader>
            {columns.map((column, i) => (
              <HeaderCell
                id="date"
                scope="col"
                key={i}
                sizeLarge={column.sizeLarge}
                sizeMedium={column.sizeMedium}
                sizeSmall={column.sizeSmall}
              >
                {column.title}
              </HeaderCell>
            ))}
          </ColumnHeader>
        )}
        {children && (
          <HeaderRow>
            <HeaderCellWhiteText>{children}</HeaderCellWhiteText>
            <HeaderCell />
            <HeaderCell />
          </HeaderRow>
        )}
      </thead>
      <tbody>
        {hasActionRow && (
          <ActionRow>
            <DataCell>{'VIA'}</DataCell>
            <DataCell>
              <Toggle
                text="email"
                label="email"
                onChange={onEmailSubscribeToggle}
                checked={emailSubscribed}
              />
            </DataCell>
            <DataCell>
              <Toggle
                text="sms"
                label="sms"
                onChange={onSmsSubscribeToggle}
                checked={smsSubscribed}
              />
            </DataCell>
            <DataCell />
          </ActionRow>
        )}
        {!rows || !rows.length ? (
          <DataRow>
            <NoResultsDataCell>{noneText}</NoResultsDataCell>
          </DataRow>
        ) : (
          rows.map((row, i) => (
            <DataRow key={i}>
              {columns.map((column, ii) => (
                <DataCell key={i + '_' + ii}>
                  {column.render ? column.render(row) : row[column.name]}
                </DataCell>
              ))}
            </DataRow>
          ))
        )}
      </tbody>
    </Table>
  </Wrapper>
);

export default SubscriptionsTable;
